module.exports = __webpack_public_path__ + "img/6.08a4ffe8.jpg";